import type { FeatureDefinitionGroup, FeatureExtractionVisibility } from '../feature-definition-types';

export type ContactsRelativePath = '/all-contacts' | '/lists';

export const featureDefinition = {
  root: '/contacts',
  iconName: 'contacts',
  items: {
    '/all-contacts': {
      label: 'All Contacts',
      trackingId: 'contact-2.0-list-menu-all',
      description: 'Displays the entire patient or client contact list, with searching and filtering capabilities.',
    },
    '/lists': {
      label: 'Lists',
      trackingId: 'contact-2.0-list-menu-lists',
      description: 'View collections lists, birthdays, and overdue patients, useful for targeted messaging.',
    },
  },
} as const satisfies FeatureDefinitionGroup<'/contacts', 'contacts', ContactsRelativePath>;

export const featureExtractionVisibility = {
  itemShowClassifications: {
    '/lists': 'runtime-conditional',
  },
} as const satisfies FeatureExtractionVisibility<ContactsRelativePath>;
